import { TagInterface } from '../interfaces/tag.interface';

export class Tag {
  /**
   * Id.
   */
  id: number;

  /**
   * Name.
   */
  name: string;

  /**
   * Color.
   */
  color: string;

  /**
   * Tag constructor.
   *
   * @param tag Tag.
   */
  constructor(tag: TagInterface) {
    this.id = tag.id;
    this.name = tag.name;
    this.color = `#${tag.color}`;
  }

  /**
   * Compare names order.
   *
   * @param tag Tag.
   * @returns number;
   */
  public isCurrentNameBeforeTagName(tag: Tag): number {
    if (this.name < tag.name) return -1;
    else if (this.name > tag.name) return 1;
    return 0;
  }
}
